__turbopack_context__.v({
  "inner": "page-content-module-scss-module__MA8w9W__inner",
  "innerFlush": "page-content-module-scss-module__MA8w9W__innerFlush",
  "innerLock": "page-content-module-scss-module__MA8w9W__innerLock",
  "outer": "page-content-module-scss-module__MA8w9W__outer",
  "outerFlush": "page-content-module-scss-module__MA8w9W__outerFlush",
  "outerLock": "page-content-module-scss-module__MA8w9W__outerLock",
});
